import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartData,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { IDetalheGiroEstoquePeriodo } from '../../../../../../types/api/estoque/relatorio-giro-estoque-detalhe';
import { listaMesesAbrv } from '../../../../../../helpers/constantes';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'bottom' as const,
        }
    },
};

function formatarMes(mes: number, ano: number): string {
    return `${listaMesesAbrv[mes - 1]}/${ano}`;
}

export function GraficoVendaSaldo({
    valores
}: GraficoVendaSaldoProps) {

    valores.sort((a, b) => {
        if (a.ano !== b.ano) {
            return b.ano - a.ano
        } else {
            return a.mes - b.mes
        }
    });

    const labels = valores.map((item) => `${formatarMes(item.mes, item.ano)}`);

    const data = {
        labels,
        datasets: [
            {
                label: 'Venda média',
                data: valores.map((item) => item.qtd_vendas),
                borderColor: 'rgba(254, 141, 3, 0.5)',
                backgroundColor: 'rgba(254, 141, 3, 0.5)',
            },
            {
                label: 'Saldo médio',
                data: valores.map((item) => item.estoque_ultimo_dia),
                borderColor: 'rgb(53, 162, 235)',
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
        ],
    };

    return <Line options={options} data={data} />;
}

interface GraficoVendaSaldoProps {
    valores: IDetalheGiroEstoquePeriodo[]
}
